export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#030408] border-t border-[#1A2545] pt-12 md:pt-16 pb-8 relative overflow-hidden">
      {/* Subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-32 bg-[#1E6BFF]/5 blur-[60px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="grid md:grid-cols-3 gap-8 md:gap-10 mb-10 md:mb-12">
          <div>
            <div className="inline-flex rounded-lg px-3 py-2 mb-4 border border-[#1A2545]">
              <img
                src="https://static.readdy.ai/image/1153be8c8a2f65c98102af48ca4fb482/2911c566eae6c7f5c4dd1968245a62b6.png"
                alt="フィジオショット"
                className="h-8 object-contain"
              />
            </div>
            <p className="text-[#D0DDF0] text-sm leading-relaxed mb-4">
              GAMMA高濃度ミネラル輻射技術による
              次世代リカバリーデバイス。
              医師監修・韓国特許取得。
              2025年5月 日本初上陸。
            </p>
            <div className="flex items-center gap-2 text-[#D0DDF0] text-xs">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-line text-[#1E6BFF] text-sm" />
              </div>
              <span>全国34施設で導入中</span>
            </div>
          </div>

          <div>
            <h4 className="text-[#E8EFFF] font-bold text-sm mb-4 tracking-wider">サービス</h4>
            <ul className="space-y-2">
              {[
                { label: '問題提起・背景', id: 'problem' },
                { label: 'GAMMAメカニズム', id: 'solution' },
                { label: 'エビデンス', id: 'evidence' },
                { label: '実績・信頼', id: 'trust' },
                { label: 'ベネフィット', id: 'benefits' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-[#D0DDF0] hover:text-[#5A9AFF] text-sm transition-colors cursor-pointer text-left"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#E8EFFF] font-bold text-sm mb-4 tracking-wider">お問い合わせ</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-user-heart-line text-[#1E6BFF] text-sm" />
                </div>
                <div>
                  <p className="text-[#E8EFFF] text-sm font-semibold">一般ユーザー</p>
                  <p className="text-[#D0DDF0] text-xs">施術体験のご予約はCTAボタンから</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-building-2-line text-[#1E6BFF] text-sm" />
                </div>
                <div>
                  <p className="text-[#E8EFFF] text-sm font-semibold">事業者・施設</p>
                  <p className="text-[#D0DDF0] text-xs">代理店・導入相談はCTAボタンから</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-time-line text-[#1E6BFF] text-sm" />
                </div>
                <div>
                  <p className="text-[#E8EFFF] text-sm font-semibold">返信時間</p>
                  <p className="text-[#D0DDF0] text-xs">通常24時間以内にご返信します</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1A2545] pt-6 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#D0DDF0] text-xs text-center md:text-left">
            &copy; 2025 フィジオショット. All rights reserved. 医師監修 | 韓国特許取得 | 日本初上陸
          </p>
          <div className="flex items-center gap-4">
            <span className="text-[#D0DDF0] text-xs">プライバシーポリシー</span>
            <span className="text-[#D0DDF0] text-xs">特定商取引法に基づく表記</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
